import { Divider } from "@mui/material";
import { grey } from "@faro-lotv/flat-ui";
import { Fragment, type JSX } from "react";
import { ProgressOverviewCard } from "./progress-overview-card";
import { ProcessInfoSource } from "./progress-overview-selectors";

type ProgressOverviewFeedProps = {
  /** The information about all processes shown in this unified feed */
  processes: ProcessInfoSource[];
};

/** @returns the feed that displays all processes */
export function ProgressOverviewFeed({
  processes,
}: ProgressOverviewFeedProps): JSX.Element {
  return (
    <>
      {processes.map((process, i) => (
        <Fragment key={process.id}>
          <ProgressOverviewCard process={process} />
          {i !== processes.length - 1 && (
            <Divider sx={{ borderColor: grey[200], mx: -0.75 }} />
          )}
        </Fragment>
      ))}
    </>
  );
}
